/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "@i18n";
import { RootState } from "@Reducers/index";

const LanguageContext = createContext({
  preferredLanguage: "en",
});

const isReactNative = typeof document === "undefined";

interface ProviderLanguageProps {
  /** ProviderApp uses this to flip `document.documentElement.dir`. */
  isRTLCallback?: (isRTL: boolean) => void;
  children?: React.ReactNode;
}

function ProviderLanguage(props: Readonly<ProviderLanguageProps>) {
  const preferredLanguage = useSelector((state: RootState) => state.preferredLanguage);

  useEffect(() => {
    const isRTL = preferredLanguage === "ar";
    props.isRTLCallback?.(isRTL);
    // fire-and-forget: an effect cannot await; i18next re-renders subscribers when the bundle lands,
    // and the localStorage write below is independent of it.
    void i18n.changeLanguage(preferredLanguage);
    if (!isReactNative) {
      globalThis.localStorage.setItem("preferredLanguage", preferredLanguage);
    }
  }, [preferredLanguage]);

  const Provider = LanguageContext.Provider;
  return (
    <Provider
      value={{
        preferredLanguage,
      }}
    >
      {props.children}
    </Provider>
  );
}

export default ProviderLanguage;
